/**
 * Interfeys matnlari — o'zbekcha.
 *
 * JSX ichida qattiq yozilgan matn YO'Q. Sabab: keyin ruscha qo'shiladi va
 * o'shanda matnlarni JSX ichidan terib chiqish og'riqli bo'ladi.
 *
 * Apostrof — o'zbekcha `'` (U+2018), ASCII `'` emas.
 */

/** Til nomlari — `match` filtri va `call` chipi bir xil yozuvni
 *  ishlatadi. Ikki joyda alohida yozilsa bittasi eskirib qoladi. */
const LANG_NAME: Record<string, string> = {
  uz: 'O‘zbek',
  ru: 'Русский',
  en: 'English',
};

export const uz = {
  langName: LANG_NAME,

  /** Dock — 5 element (SPEC §5). Yorliqlar prototip 994-1015 dan. */
  dock: {
    label: 'Asosiy menyu',
    home: 'Bosh',
    top: 'Reyting',
    match: '1v1',
    chats: 'Xabar',
    profile: 'Profil',
    // Faza 1 da uchta tugma yopiq. Matn "ishlamayapti" emas, "hali yo'q"
    // deydi — foydalanuvchi buni xato deb o'ylamasin.
    roomsSoon: 'Roomlar tez orada ochiladi',
  },

  /** Room ekrani — docs/SPEC.md §room. */
  room: {
    hostBadge: 'HOST',
    emptySeat: 'bo‘sh',
    askMic: 'Mikrofon so‘rash',
    micAsked: 'So‘rov ketdi ✓',
    stepDown: 'Mikrofondan tushish',
    seatTaken: 'Bu o‘rin band bo‘lib ulgurdi',
    chatEmpty: 'Hali hech kim yozmagan',
    chatPlaceholder: 'Xabar yozing',
    gone: 'Bu room tugagan',
    passwordNeeded: 'Bu room parol bilan — havolani bergan odamdan kodni so‘rang',
    joinFailed: 'Roomga kirib bo‘lmadi',
    closedByHost: 'Host efirni tugatdi',
    closedByAdmin: 'Room moderator tomonidan yopildi',
    reconnecting: 'Qayta ulanmoqda…',
    // Mikrofonsiz ham roomda qolish mumkin — 1v1 dan farqi shu.
    noMic: 'Mikrofonga ruxsat berilmadi — tinglashda davom etasiz',
    listeners: (count: number) => `${count} tinglovchi`,
    micRequestFrom: (name: string) => `${name} mikrofon so‘rayapti`,
    // Yuboruvchi aynan SHU ko'rinish uchun to'laydi (qoida 2).
    sponsors: 'Bugungi top homiy',
    // Bo'sh holat matnsiz qolmaydi (qoida 19) va u ayni paytda taklif:
    // qator hali egasiz ekani birinchi sovg'ani arziydigan qiladi.
    sponsorsEmpty: 'Bugun hali homiy yo‘q',
  },

  /** Bosh sahifa va room yaratish — SPEC §home, §create. */
  home: {
    greeting: (name: string) => `Salom, ${name}`,
    liveNow: 'Hozir efirda',
    featured: 'Hafta tanlovi',
    live: 'JONLI',
    searchPlaceholder: 'Room qidirish',
    categoryAll: 'Hammasi',
    noMatch: 'Bu filtr bo‘yicha room topilmadi',
    // D-006: TOP faqat score bo'yicha, shuning uchun yangi host uchun
    // ALOHIDA bo'lim kerak — aks holda u hech qachon ko'rinmaydi.
    fresh: 'Yangi roomlar',
    empty: 'Hozir jonli room yo‘q — birinchi bo‘lib boshlang',
    create: 'Room ochish',
    locked: 'VIP zalga faqat taklif bilan kiriladi',
    loadFailed: 'Roomlarni yuklab bo‘lmadi',
    // Flag o'chiq — bu XATO emas, holat. Matn ham shunday deydi.
    roomsSoon: 'Roomlar tez orada ochiladi. Hozircha 1v1 suhbat mavjud.',
  },

  create: {
    title: 'O‘z roomingiz',
    name: 'NOMI',
    namePlaceholder: 'Masalan: Kechki suhbat',
    topic: 'MAVZU',
    type: 'TURI',
    typeOpen: 'Ochiq',
    typeOpenHint: 'Havolasi bo‘lgan har kim kiradi',
    typeLocked: 'Parol bilan',
    typeLockedHint: 'Faqat siz bergan kod bilan kiradi',
    passwordPlaceholder: 'Kod (kamida 4 belgi)',
    seats: 'MIKROFON O‘RINLARI',
    start: 'Efirni boshlash',
  },

  /** Reyting — ikki o'q (SPEC X-7, D-003). */
  top: {
    title: 'Reyting',
    charm: 'Charm',
    level: 'Level',
    you: 'Sizning o‘rningiz',
    period: { today: 'Bugun', week: 'Hafta', month: 'Oy' },
    emptyCharm: 'Bu davrda hali sovg‘a berilmagan',
    emptyLevel: 'Bu davrda hali hech kim efirga chiqmagan',
  },

  common: {
    loading: 'Yuklanmoqda…',
    retry: 'Qayta urinish',
    cancel: 'Bekor qilish',
    error: 'Xato yuz berdi',
    networkError: "Aloqa yo'q — internetni tekshiring",
  },

  gate: {
    onlyTelegram: 'Bu ilova faqat Telegram ichida ishlaydi',
    onlyTelegramHint: 'Botni oching va "Ovozli suhbatni ochish" tugmasini bosing',
    authFailed: 'Kirish amalga oshmadi',
    expired: 'Kirish muddati tugagan — ilovani qayta oching',
  },

  nav: {
    home: 'Bosh sahifa',
    top: 'Reyting',
    match: '1v1',
    chats: 'Xabar',
    profile: 'Profil',
  },

  soon: {
    title: 'Tez orada',
    rooms: 'Roomlar hozircha ochilmagan',
    hint: 'Bu bo‘lim keyingi bosqichda ishga tushadi',
  },

  profile: {
    title: 'Profil',
    level: 'Lv',
    idCopied: 'ID nusxalandi — do‘stlaringizga yuboring',
    idCopyFailed: 'Nusxalab bo‘lmadi — ID ni qo‘lda yozib oling',
    charm: 'Charm',
    /** D-003: charm sotib olinadi, level yo'q. Shuning uchun bu yerda `Lv` izohi YO'Q. */
    charmRank: (rank: string) => `Charm reytingida ${rank}-o‘rin`,
    charmEmpty: 'Hali charm yo‘q — sovg‘a olsangiz to‘ladi',
    air: 'Efirda',
    airHours: (hours: string) => `${hours} soat`,
    streak: (days: string) => `${days} kun ketma-ket efirda`,
    streakNone: 'Ketma-ketlik hali boshlanmagan',
    vipTitle: 'VIP Oltin',
    vipHint: 'Oltin ramka, kirish effekti va +30% charm',
    // Sotib olish oqimi faza 1 da yo'q (Q-044). Tugma o'rniga holat.
    vipSoon: 'Tez orada',
    vipActive: (date: string) => `${date} gacha`,
    gifts: 'Olingan sovg‘alar',
    giftsEmpty: 'Hali sovg‘a yo‘q — efirga chiqing yoki 1v1 boshlang',
    loadFailed: 'Profilni yuklab bo‘lmadi',
  },

  match: {
    label: '1 VS 1',
    title: 'Tasodifiy suhbatdosh',
    hint: 'Filtrni tanlang — tizim hozir bo‘sh turgan odamni topib beradi.',
    gender: 'JINSI',
    male: 'Erkak',
    female: 'Ayol',
    anyGender: 'Farqi yo‘q',
    age: 'YOSHI',
    lang: 'TILI',
    langUz: LANG_NAME['uz'],
    langRu: LANG_NAME['ru'],
    langEn: LANG_NAME['en'],
    anyLang: 'Farqi yo‘q',
    anonTitle: 'Anonim rejim',
    anonHint: (minutes: string) => `Ism va rasm birinchi ${minutes} daqiqa yopiq turadi`,
    start: 'Qidirishni boshlash',
    notEnough: 'Diamond yetarli emas',
    topup: 'Hamyonni to‘ldirish',
    profileIncomplete: 'Avval jins va yoshni ko‘rsating',
  },

  /** `profile/edit` — jins va yosh 1v1 filtri uchun MAJBURIY. */
  profileEdit: {
    title: 'Profil',
    name: 'ISM',
    namePlaceholder: 'Ismingiz',
    gender: 'JINSI',
    male: 'Erkak',
    female: 'Ayol',
    birthYear: 'TUG‘ILGAN YIL',
    birthYearPlaceholder: 'Masalan, 2004',
    /** Nega so‘ralayotgani ochiq aytiladi — 16+ ilova (D-018). */
    hint: 'Jins va yosh 1v1 qidiruvida ishlatiladi. Ular boshqalarga ko‘rinadi.',
    save: 'Saqlash',
    saved: 'Saqlandi',
    /** Server ham tekshiradi (`UNDERAGE`) — bu faqat birinchi qatlam. */
    underage: (min: string) => `Ilovadan ${min} yoshdan boshlab foydalanish mumkin`,
    badYear: 'Tug‘ilgan yilni to‘g‘ri kiriting',
    nameRequired: 'Ismni kiriting',
  },

  search: {
    /** Bosqichlar REAL matchmaking holatiga bog‘langan — soxta progress emas (SPEC). */
    queued: 'Mos odam qidirilmoqda',
    queuedHint: (count: string) => `${count} kishi hozir bo‘sh turibdi`,
    found: 'Mos odam topildi',
    foundHint: 'Ovoz kanali tayyorlanmoqda',
    cancel: 'Bekor qilish',
    /** Prototipda YO‘Q, lekin majburiy (SPEC `search`) — diamond qaytariladi. */
    empty: 'Hozir mos odam yo‘q — filtrni kengaytiring yoki keyinroq urinib ko‘ring',
    refunded: (amount: string) => `${amount} diamond qaytarildi`,
    disconnected: 'Aloqa uzildi — qidiruvni qayta boshlang',
  },

  call: {
    /** WebRTC DTLS-SRTP bilan shifrlaydi — bu bayonot to‘g‘ri. */
    encrypted: 'SHIFRLANGAN QO‘NG‘IROQ',
    anonymous: 'Anonim',
    revealIn: (minutes: string) => `${minutes} daqiqadan keyin ochiladi`,
    mute: 'Mikrofonni o‘chirish',
    unmute: 'Mikrofonni yoqish',
    hangUp: 'Tugatish',
    gift: 'Sovg‘a yuborish',
    /** SPEC §call 201 — pastki qatordagi beshta tugmadan biri.
     *  Do‘stlashish AYNAN shu yerda: 1v1 — odam bilan tanishadigan
     *  yagona joy, ID bo‘yicha qo‘shish esa olib tashlandi. */
    addFriend: 'Do‘stlikka chorlash',
    friendSent: 'Do‘stlik so‘rovi yuborildi',
    speakerOn: 'Ovozni yoqish',
    speakerOff: 'Ovozni o‘chirish',
    peerLeft: 'Suhbatdosh chiqdi',
    /** Holat matni — jim uzilish TAQIQLANADI (docs/API.md §12). */
    state: {
      connecting: 'Ulanmoqda…',
      connected: 'Ovoz ulandi',
      reconnecting: 'Aloqa tiklanmoqda…',
      'no-mic': 'Mikrofonga ruxsat bering — brauzer sozlamalaridan',
      failed: 'Ulanib bo‘lmadi — qayta urinib ko‘ring',
      closed: 'Qo‘ng‘iroq tugadi',
    },
  },

  gift: {
    title: 'Sovg‘a yuborish',
    tierPopular: 'Ommabop',
    tierLuxe: 'Lyuks',
    tierVip: 'VIP',
    send: 'Yuborish',
    /** D-062 — x99 kombo bitta bosishda katta summani yechadi. */
    confirm: (total: string) => `Tasdiqlash · ${total} diamond`,
    notEnough: 'Diamond yetarli emas — hamyonni to‘ldiring',
    empty: 'Bu darajada sovg‘a yo‘q',
    sent: 'Sovg‘a yuborildi',
    received: (name: string) => `${name} sovg‘a yubordi`,
  },

  shop: {
    title: 'Hamyon',
    balance: 'BALANS',
    spentToday: 'Bugun sarflandi',
    /** X-1: prototipda "Sovg'alardan tushdi" DIAMONDDA edi — D-002 ni buzardi. */
    charmEarned: 'Olingan charm',
    topup: 'Diamond to‘ldirish',
    bonus: (amount: string) => `+${amount} bonus`,
    payMethod: 'To‘lov usuli',
    stars: 'Telegram Stars',
    starsHint: 'Bir bosishda · komissiya yo‘q',
    click: 'Click',
    clickHint: 'Karta yoki Click Up · tashqi brauzerda',
    buy: (amount: string) => `${amount} 💎 sotib olish`,
    buyEmpty: 'Paketni tanlang',
    legal:
      'To‘lov Telegram orqali xavfsiz o‘tadi, kvitansiya botga keladi. Sarflangan diamondlar qaytarilmaydi.',
    paying: 'To‘lov oynasi ochilmoqda…',
    paid: 'To‘lov qabul qilindi — balans bir zumda yangilanadi',
    cancelled: 'To‘lov bekor qilindi',
    failed: 'To‘lov amalga oshmadi — qayta urinib ko‘ring',
    noPacks: 'Paketlar hozircha mavjud emas',
    loadFailed: 'Hamyonni yuklab bo‘lmadi',
    telegramOnly: 'To‘lov faqat Telegram ichida ishlaydi',
  },

  /** `onboard` — 3 qadam, bitta ekran (SPEC §onboard, faza 4). */
  onboard: {
    badge: 'JONLI SUHBAT',
    skip: 'O‘tkazish',

    /** 0-qadam. Ikkinchi qator gradient matn (SPEC). */
    hookLine1: 'Yozishmang.',
    hookLine2: 'Gaplashing.',
    hookHint: 'Bir bosishda tasodifiy odam bilan ovozli suhbat. Yozish yo‘q, kutish yo‘q.',
    hookCta: 'Ha, gaplashaman',

    /** 1-qadam — jins va yosh. Ikkalasi ham 1v1 filtri uchun MAJBURIY. */
    whoTitle: 'Siz kimsiz?',
    whoHint: 'Bu ma’lumot suhbatdosh tanlashda ishlatiladi.',
    gender: 'JINSI',
    male: 'Erkak',
    female: 'Ayol',
    age: 'YOSHINGIZ',
    whoCta: 'Davom etish',
    /** 16+ (D-018) — server ham tekshiradi. */
    underage: (min: string) => `Ilovadan ${min} yoshdan boshlab foydalanish mumkin`,
    pickGender: 'Jinsni tanlang',
    pickAge: 'Yoshni tanlang',

    /** 2-qadam — mikrofon va offerta. */
    micTitle: 'Mikrofonga ruxsat',
    micLine1: 'Ovoz faqat suhbat davomida uzatiladi.',
    micLine2: 'Suhbat yozib olinmaydi — na bizda, na serverda.',
    micCta: 'Ruxsat berib kirish',
    /** D-018: offerta qabuli MAJBURIY va u ochiq aytiladi. */
    consent: 'Davom etish orqali offerta va maxfiylik siyosatiga rozilik bildirasiz.',
    micDenied: 'Mikrofonsiz ham kirasiz — 1v1 uchun keyin ruxsat berasiz',
  },

  /** `chats` — do'stlar va suhbatlar (SPEC §chats, faza 3). */
  chats: {
    title: 'Xabarlar',
    requests: (count: string) => `${count} yangi so‘rov`,
    online: 'HOZIR ONLAYN',
    conversations: 'SUHBATLAR',
    accept: 'Qabul qilish',
    reject: 'Rad etish',
    /** Prototip 293 — bo‘sh holat matnsiz qolmaydi (qoida 19).
     *  "ID bo‘yicha qidiring" OLIB TASHLANDI: do‘stlashish endi faqat
     *  1v1 da, ya‘ni bu ekranda bunday yo‘l yo‘q va matn bo‘lmagan
     *  narsani va‘da qilmasligi kerak. */
    empty: 'Hali do‘st yo‘q — 1v1 da tanishing va suhbatdoshingizni do‘stlikka chorlang',
    emptyThreads: 'Hali suhbat yo‘q — do‘stingizga birinchi bo‘lib yozing',
    /** Holat nuqtasi izohi — ekranda faqat rang, bu esa skrinrider uchun. */
    presenceOnline: 'onlayn',
    presenceLive: 'efirda',
    presenceBusy: 'band',
    presenceOffline: 'oflayn',
    failed: 'Bo‘lmadi — keyinroq urinib ko‘ring',
  },

  /** `dm` — yozishma (SPEC §dm, faza 3). */
  dm: {
    placeholder: 'Xabar yozing…',
    send: 'Yuborish',
    empty: 'Suhbatni boshlang',
    loadFailed: 'Suhbatni yuklab bo‘lmadi',
    /** Ban yoki bloklashda kiritish paneli o‘rniga shu chiqadi. */
    closed: 'Bu suhbatga yozib bo‘lmaydi',
    report: 'Shikoyat qilish',
    /** Javob — pufakka bosilganda. Matn ekranda ko‘rinmaydi, u
     *  skrinrider uchun: harakatni ikonka emas, pufakning o‘zi beradi. */
    replyAction: 'Javob berish',
    replyCancel: 'Javobni bekor qilish',
    /** Iqtibos sarlavhasi — asl xabar o‘zimniki bo‘lsa. */
    replySelf: 'Siz',
  },

  /** Shikoyat — UCH bosish: ochish → sabab → yuborish. */
  report: {
    title: 'Shikoyat',
    hint: 'Sababni tanlang. Moderator ko‘rib chiqadi.',
    spam: 'Spam yoki reklama',
    harassment: 'Haqorat yoki tahdid',
    adult: 'Nomaqbul mazmun',
    scam: 'Aldov yoki firibgarlik',
    underage: 'Voyaga yetmagan',
    other: 'Boshqa sabab',
    send: 'Yuborish',
    sent: 'Shikoyat yuborildi — rahmat',
    failed: 'Shikoyat yuborilmadi',
  },

  settings: {
    title: 'Sozlamalar',
    groupAccount: 'HISOB',
    groupPrivacy: 'MAXFIYLIK',
    groupApp: 'ILOVA',
    editProfile: 'Profilni tahrirlash',
    wallet: 'Diamond va tranzaksiyalar',
    vip: 'VIP obuna',
    vipNone: 'Yo‘q',
    quietJoin: 'Roomga jim holda kirish',
    hideOnline: 'Onlayn ekanimni yashirish',
    blocked: 'Bloklanganlar',
    notifications: 'Bildirishnomalar',
    language: 'Til',
    languageUz: 'O‘zbek',
    legal: 'Offerta va maxfiylik siyosati',
    groupDanger: 'HISOBNI BOSHQARISH',
    deleteAccount: 'Hisobni o‘chirish',
    help: 'Yordam va qo‘llab-quvvatlash',
    notYet: 'Bu bo‘lim keyingi bosqichda ochiladi',
  },
} as const;

export type Dictionary = typeof uz;
